import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminPortfolio = lazy(() => import('../pages/admin/portfolio/page'));
const AdminTeam = lazy(() => import('../pages/admin/team/page'));
const AdminCertifications = lazy(() => import('../pages/admin/certifications/page'));
const AdminEquityLogos = lazy(() => import('../pages/admin/equity-logos/page'));
const PrivacyPolicy = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfService = lazy(() => import('../pages/terms-of-service/page'));
const Disclaimer = lazy(() => import('../pages/disclaimer/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfService />,
  },
  {
    path: '/disclaimer',
    element: <Disclaimer />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/portfolio',
    element: <AdminPortfolio />,
  },
  {
    path: '/admin/team',
    element: <AdminTeam />,
  },
  {
    path: '/admin/certifications',
    element: <AdminCertifications />,
  },
  {
    path: '/admin/equity-logos',
    element: <AdminEquityLogos />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
